import { useContext } from 'use-context-selector';

import { DataContext } from '../../contexts/Data.context';

export const useBootstrapData = () => useContext(DataContext);
